import React, { useCallback } from 'react';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { StyledBox, StyledText } from '../../../../common/ui/picker/styled.tsx';
import messages from './messages.tsx';

type Props = {
	onRetry: (() => void) | null;
};

const ErrorMessage = ({ onRetry }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const onClick = useCallback(() => {
		onRetry?.();
		fireOperationalAnalytics(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
	}, [onRetry, createAnalyticsEvent]);

	return (
		<StyledBox
			height={144}
			data-testid="jql-builder-basic-picker.ui.async-select.menu-list.error-message"
		>
			<StyledBox height={72} iconSize={72}>
				<ErrorIcon spacing="spacious" color={token('color.icon')} label="" />
			</StyledBox>
			<StyledText>{formatMessage(messages.errorMessage)}</StyledText>
			<Button
				onClick={onClick}
				appearance="link"
				testId="jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
			>
				{formatMessage(messages.retryMessage)}
			</Button>
		</StyledBox>
	);
};

export default ErrorMessage;
